/**
 * Creates initial mapping structure
 */
export const createMappingStructure = (shapes = null, sizes = null, colors = null, shanks = null, materials = null, materialList = []) => {
  const mapping = {};

  if (shapes) {
    mapping.shapes = shapes.map(shape => ({
      ...shape,
      id: `shape-${shape.id}`,
      type: 'shape',
      checked: true,
      children: sizes?.map(size => ({
        ...size,
        id: `${shape.id}-size-${size.id}`,
        type: 'size',
        checked: true,
        children: shanks?.map(shank =>({
          ...shank,
          id: `${shape.id}-${size.id}-shank-${shank.id}`,
          type: 'shank',
          checked: true,
        }))
      })) || []
    }));
  }

  if (materialList?.length > 0 && materials?.length > 0) {
    const allowedMaterialSkus = new Set(materials);
    mapping.materials = materialList.map(material => ({
      ...material,
      id: `material-${material.id}`,
      type: 'material',
      checked: allowedMaterialSkus.has(material.sku_code),
    }));
  } else if (materialList?.length > 0) {
    mapping.materials = materialList.map(material => ({
      ...material,
      id: `material-${material.id}`,
      type: 'material',
      checked: true,
    }));
  }
  if (colors) {
    mapping.colors = colors.map(color => ({
      ...color,
      id: `color-${color.id}`,
      name: color.school_color_name || color.name,
      type: 'color',
      checked: true,
    }));
  }

  return mapping;
};

/**
 * Gets selected mappings
 */
export const getSelectedMappings = (mappingData) => {
  if (!mappingData) return [];

  const selectedMappings = [];
  const { shapes, materials, colors } = mappingData;

  const selectedMaterials = materials?.filter(m => m.checked) || [];
  const DEFAULT_MATERIAL_SKU = selectedMaterials[0]?.sku_code || '';
  const selectedColors = colors?.filter(c => c.checked) || [];

  shapes?.forEach(shape => {
    if (shape.checked) {
      shape.children?.forEach(size => {
        if (size.checked) {
          size.children?.forEach(shank => {
            if (shank.checked) {
              selectedMaterials.forEach(material => {
                selectedColors.forEach(color => {
                  if (color.sku === 'NONE' || material.sku_code === DEFAULT_MATERIAL_SKU) {
                  selectedMappings.push({
                    key: `${shape.sku}-${material.id}-${color.id}-${size.sku}-${shank.sku}`,
                      shape,
                      size,
                      shank,
                      material,
                      color
                    });
                  }
                });
              });
            }
          });
        }
      });
    }
  });

  return selectedMappings;
};

/**
 * Updates checked state for any mapping type
 */
export const updateMappingChecked = (mappingData, type, id, checked) => {
  switch (type) {
    case 'material':
      return {
        ...mappingData,
        materials: mappingData.materials?.map(material => 
          material.id === id ? { ...material, checked } : material
        )
      };
      
    case 'color':
      return {
        ...mappingData,
        colors: mappingData.colors?.map(color => 
          color.id === id ? { ...color, checked } : color
        )
      };
      
    case 'shape':
      return {
        ...mappingData,
        shapes: mappingData.shapes?.map(shape => 
          shape.id === id 
            ? updateNodeAndChildren(shape, checked)
            : shape
        )
      };

    case 'size':
      return {
        ...mappingData,
        shapes: mappingData.shapes?.map(shape => ({
          ...shape,
          children: shape.children?.map(size =>
            size.id === id ? { ...size, checked } : size
          )
        }))
      };
    
    case 'shank':
      return {
        ...mappingData,
        shapes: mappingData.shapes?.map(shape => ({
          ...shape,
          children: shape.children?.map(size => ({
            ...size,
            children: size.children?.map(shank =>
              shank.id === id ? { ...shank, checked } : shank
            )
          }))
        }))
      };
    
    default:
      return mappingData;
  }
};

const updateNodeAndChildren = (node, checked) => ({
  ...node,
  checked,
  children: node.children?.map(child => ({
    ...child,
    checked: checked ? child.checked : false
  }))
}); 